import { AcknowledgmentAction } from 'legacy/lut/components/widgets/public/partner360/commitment/enums/AckonwledgmentAction'
import { ICommitmentEditorItem } from 'legacy/lut/components/widgets/public/partner360/commitment/models'
import { requestRecalculateCompleteness } from 'legacy/lut/features/partner360/completeness'
import { getOwnerId } from 'legacy/lut/selectors/app'
import { callAcknowledgmentAction } from 'legacy/lut/services/partner360/commitment/callAcknowledgmentAction'
import { ICallAcknowledgmentActionParameters } from 'legacy/lut/services/partner360/commitment/models/callAcknowledgmentActionParameters'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { REQUEST_ACKNOWLEDGEMENT } from '../constants'

export interface IRequestAcknowledgementParameters
  extends Omit<ICallAcknowledgmentActionParameters, 'ownerId'> {}

export const requestAcknowledgement = createAsyncThunk<
  ICommitmentEditorItem[],
  IRequestAcknowledgementParameters
>(REQUEST_ACKNOWLEDGEMENT, async (parameters, { getState, dispatch }) => {
  const ownerId = compose(getOwnerId, getState)()

  const result = await callAcknowledgmentAction({
    ownerId,
    ...parameters,
  })

  if (
    (parameters.actionData.Action === AcknowledgmentAction.Add ||
      parameters.actionData.Action === AcknowledgmentAction.Remove) &&
    parameters.partnerId &&
    parameters.fYear
  ) {
    await dispatch(
      requestRecalculateCompleteness({
        partnerId: parameters.partnerId,
        fYear: parameters.fYear,
      })
    ).unwrap()
  }

  return result
})
